import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center py-8">
      <p className="font-montserrat">© 2025 Techpack Creators. All rights reserved.</p>
    </footer>
  );
}

export default Footer;